import * as React from "react";
import Modal from "react-bootstrap/Modal";
import { PSF_ProtectiveFunctionComments } from "../models/PSF_ProtectiveFunctionComments";
import Draggable from "react-draggable";

interface Props {
  closeModal: () => void;
  handleProcessHazardUpdate: (process_hazard: string) => void;
  shownModal: string;
  saveSrsNotes: (notes: string, srsType: string) => void;
  psf_ProtectiveFunctionComments: PSF_ProtectiveFunctionComments;
}

interface State {
  closeFocus: boolean;
}

export class SrsModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { closeFocus: false };
  }

  private txt_srs = React.createRef<HTMLTextAreaElement>();

  handleClick(e) {
    var srs = this.txt_srs.current.value;
    this.props.handleProcessHazardUpdate(srs);
    this.props.closeModal();
  }

  onMouseEnter = () => {
    this.setState({
      closeFocus: true
    });
  };

  onMouseLeave = () => {
    this.setState({
      closeFocus: false
    });
  };

  saveSrs = () => {
    this.props.saveSrsNotes(this.txt_srs.current.value, this.props.shownModal);
    this.props.closeModal();
  };

  render() {
    const closeModal = this.props.closeModal;
    var shownModal = this.props.shownModal;
    var psf_ProtectiveFunctionComments = this.props
      .psf_ProtectiveFunctionComments;

    var closeClass = this.state.closeFocus
      ? "ui-dialog-titlebar-close ui-corner-all ui-state-hover"
      : "ui-dialog-titlebar-close ui-corner-all";
    var notes = "";

    switch (shownModal) {
      case "Process Hazard": {
        notes = psf_ProtectiveFunctionComments.processHazard;
        break;
      }
      case "Description": {
        notes = psf_ProtectiveFunctionComments.sourceDescription;
        break;
      }
      case "Diagnostics": {
        notes = psf_ProtectiveFunctionComments.sourceDiagnostics;
        break;
      }
      case "Reset": {
        notes = psf_ProtectiveFunctionComments.resetFunction;
        break;
      }
      case "Shutdown": {
        notes = psf_ProtectiveFunctionComments.shutdownDescription;
        break;
      }
      case "Reference": {
        notes = psf_ProtectiveFunctionComments.referDocuments;
        break;
      }
      case "Comments": {
        notes = psf_ProtectiveFunctionComments.sourceComments;
        break;
      }
    }

    return (
      <Modal
        show={true}
        animation={false}
        centered={true}
        onEscapeKeyDown={() => closeModal()}
        onHide={() => {
          /* don't allow hide via off-click*/
        }}
        size="lg"
        enforceFocus={true}
        style={{ zIndex: 10000, background: "rgba(000, 000, 000, 0.5)" }}
      >
        <Draggable axis="both" handle=".ui-dialog-titlebar">
          <div
            className="ui-dialog ui-widget ui-widget-content ui-corner-all ui-draggable"
            tabIndex={-1}
            role="dialog"
            aria-labelledby="ui-dialog-title-popup"
            style={{
              display: "block",
              zIndex: 1002,
              outline: "0px",
              height: "auto",
              width: "auto",
              top: "370px",
              left: "50px"
            }}
          >
            <div className="ui-dialog-titlebar ui-widget-header ui-corner-all ui-helper-clearfix">
              <span className="ui-dialog-title" id="ui-dialog-title-popup">
                {shownModal}
              </span>
              <div className={closeClass} role="button">
                <span
                  className="ui-icon ui-icon-closethick"
                  style={{ cursor: "pointer" }}
                  onMouseEnter={this.onMouseEnter}
                  onMouseLeave={this.onMouseLeave}
                  onClick={() => closeModal()}
                >
                  close
                </span>
              </div>
            </div>
            <div
              id="popup"
              style={{
                width: "auto",
                height: "auto",
                backgroundColor: "rgb(120, 120, 120)",
                display: "block",
                minHeight: "0px"
              }}
              className="ui-dialog-content ui-widget-content"
            >
              <div style={{ margin: "auto" }}>
                <textarea
                  name="srs"
                  rows={17}
                  cols={60}
                  id="srstext"
                  defaultValue={notes}
                  ref={this.txt_srs}
                />
              </div>
              <div style={{ paddingLeft: "200px", paddingTop: "20px" }}>
                <input
                  type="submit"
                  name="Save_Srs"
                  value="Save"
                  id="Save_Srs"
                  onClick={() => this.saveSrs()}
                />
              </div>
            </div>
          </div>
        </Draggable>
      </Modal>
    );
  }
}
